var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuggestions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777777"
    },
    d: "M512,378.435v89.043l0,0C512,492.066,492.066,512,467.478,512H44.522C19.933,512,0,492.066,0,467.478 l0,0v-89.043H512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C"
    },
    d: "M475.826,467.478c0,4.61-3.738,8.348-8.348,8.348h-244.87c-4.61,0-8.348-3.738-8.348-8.348 s3.736-8.348,8.348-8.348h244.87C472.088,459.13,475.826,462.868,475.826,467.478z M180.313,459.13H179.2 c-4.61,0-8.348,3.738-8.348,8.348s3.738,8.348,8.348,8.348h1.113c4.61,0,8.348-3.738,8.348-8.348S184.923,459.13,180.313,459.13z  M122.435,459.13h-1.113c-4.61,0-8.348,3.738-8.348,8.348s3.738,8.348,8.348,8.348h1.113c4.61,0,8.348-3.738,8.348-8.348 S127.045,459.13,122.435,459.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBD8D2"
    },
    d: "M512,378.435L512,378.435c0,24.588-19.933,44.522-44.522,44.522H44.522 C19.933,422.957,0,403.023,0,378.435l0,0c0-24.588,19.933-44.522,44.522-44.522h422.957C492.066,333.913,512,353.847,512,378.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5A5A5"
    },
    d: "M111.304,389.565H56.002c-4.571,0-8.557-3.522-8.694-8.091c-0.141-4.728,3.649-8.605,8.344-8.605 h66.783v5.565C122.435,384.582,117.452,389.565,111.304,389.565z M455.998,372.87h-66.433v5.565c0,6.147,4.983,11.13,11.13,11.13 h55.652c4.696,0,8.486-3.877,8.344-8.605C464.554,376.391,460.568,372.87,455.998,372.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC8059"
    },
    d: "M400.696,211.478v178.087h-89.043c-12.295,0-22.261-9.966-22.261-22.261V211.478 c0-12.295,9.966-22.261,22.261-22.261h66.783C390.729,189.217,400.696,199.184,400.696,211.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF5243"
    },
    d: "M333.913,233.739v155.826h-22.261c-12.295,0-22.261-9.966-22.261-22.261V211.478h22.261 C323.947,211.478,333.913,221.444,333.913,233.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3CCAA"
    },
    d: "M311.652,22.261v367.304H244.87c-24.588,0-44.522-19.933-44.522-44.522V22.261 C200.348,9.966,210.314,0,222.609,0h66.783C301.686,0,311.652,9.966,311.652,22.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80A886"
    },
    d: "M244.87,144.696v244.87h-22.261c-12.295,0-22.261-9.966-22.261-22.261v-244.87h22.261 C234.903,122.435,244.87,132.401,244.87,144.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED766"
    },
    d: "M222.609,122.435v267.13H111.304v-267.13c0-12.295,9.966-22.261,22.261-22.261h66.783 C212.643,100.174,222.609,110.14,222.609,122.435z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestions);
export default __webpack_public_path__ + "static/media/suggestions.12976b4f89a5c1153bf501eb3b8d8e1a.svg";
export { ForwardRef as ReactComponent };